import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import IconItem from '../exercise/checker/icon-item';

const Container = styled.div`
    display: inline-flex;
    justify-content: space-between;
`;

const Label = styled.div`
    display: flex;
    align-items: center;

    font-size: 12px;
    font-weight: 600;
`;

const ButtonsContainer = styled.div`
    display: inline-flex;
`;

export const Number = styled.input`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;

        background-color: ${theme.colors['surface-white']};
        border: 1px solid black;
        text-align: center;
        height: 36px;
        width: 36px;
    `}
`;

const Button = styled.div`
    ${({ theme, disabled }) => css`
        display: flex;
        align-items: center;
        justify-content: center;

        background-color: ${theme.colors['surface-white']};
        border-radius: 0px 4px 4px 0px;
        border: 1px solid ${theme.colors['myzanichelli-blue-main']};
        height: 36px;
        width: 36px;

        cursor: pointer;
        pointer-events: ${disabled && 'none'};

        &:hover {
            background-color: ${theme.colors['surface-grey-050']};
            outline: 0;
        }

        &:active {
            background-color: ${theme.colors['surface-grey-200']};
            box-shadow: ${theme.shadows['shadow-02dp']};
            outline: 0;
        }

        &[disabled] {
            border: 1px solid ${theme.colors['surface-grey-200']};
            background-color: ${theme.colors['surface-white']};
            color: ${theme.colors['text-grey-700']};
            cursor: initial;
            box-shadow: none;
        }
    `}
`;

export const PlusButton = styled(Button)`
    border-radius: 0px 4px 4px 0px;
    border-left: none;
`;

export const MinusButton = styled(Button)`
    border-radius: 4px 0px 0px 4px;
    border-right: none;
`;

const Icon = styled(IconItem)`
    ${({ theme, disabled }) => css`
        fill: ${theme.colors['text-myzanichelli-blue-main']};
        margin: ${theme.space.xs}px;
        height: 18px;
        width: 18px;

        :hover {
            fill: ${theme.colors['text-myzanichelli-blue-dark']};
        }

        ${disabled &&
        css`
            fill: ${theme.colors['text-grey-700']};
        `}
    `}
`;

const Counter = ({ label, onChange, min = 1, max = 99, value }) => {
    const handleChange = (value) => {
        const parsedNumber = parseInt(value.replace(/\D/g, ''));

        if (isNaN(parsedNumber)) {
            return min;
        }
        if (parsedNumber < min) {
            return min;
        }
        if (parsedNumber > max) {
            return max;
        }
        return parsedNumber;
    };

    return (
        <Container>
            <Label>{label}</Label>
            <ButtonsContainer>
                <MinusButton
                    disabled={value === min}
                    onClick={() => {
                        onChange(value - 1);
                    }}
                >
                    <Icon name="minus" disabled={value === 1} />
                </MinusButton>
                <Number
                    value={value}
                    onChange={(event) => {
                        onChange(handleChange(event.target.value));
                    }}
                />
                <PlusButton
                    disabled={value === max}
                    onClick={() => {
                        onChange(value + 1);
                    }}
                >
                    <Icon name="plus" />
                </PlusButton>
            </ButtonsContainer>
        </Container>
    );
};

Counter.propTypes = {
    label: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
    value: PropTypes.number,
};

export default Counter;
